export default __webpack_public_path__ + "static/media/marketing.bf661a7c.svg";